<template>
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24"><path fill="currentColor" d="M8.186 3.526a1.87 1.87 0 0 0-1.894-.036c-.59.332-.957.957-.957 1.637v13.748c0 .68.367 1.304.957 1.636s1.316.316 1.894-.035l11.248-6.874a1.876 1.876 0 0 0 0-3.203z"/></svg>
</template>